import React, { Suspense, useContext, useEffect } from "react";
import { ThemeProvider, createGlobalStyle } from "styled-components";
// import { StylesProvider } from "@material-ui/styles";
import {
  createMuiTheme,
  ThemeProvider as ThemeProviderUI,
} from "@material-ui/core/styles";

import { lightTheme, darkTheme } from "./Theme";
import useDarkMode from "use-dark-mode";
import { GlobalContext } from "../../common/providers/GlobalState";

import useLocalStorage from "../../service/useLocalStorage";
import { useTranslation } from "react-i18next";

export const ThemeProviders = (props) => {
  const { i18n } = useTranslation();
  const darkMode = useDarkMode(true);
  const theme = darkMode.value ? darkTheme : lightTheme;

  const [{}, dispatch] = useContext(GlobalContext);
  const [Storageproducts] = useLocalStorage("products", []);
 
  const Font =
    i18n.language === "en"
      ? `"Open Sans", sans-serif`
      : `"Kanit", sans-serif`;

  const THEME = createMuiTheme({
    typography: {
      fontFamily: Font,
      fontSize: 14,
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightMedium: 500,
    },
  });

  const GlobalStyle = createGlobalStyle` 
  body {
    background-color: ${(props) => props.theme.body.bg};
    // background-image: ${props => props.theme.bgimage};   
    color: ${(props) => props.theme.text.primary};    
    font-family: ${Font};
  }
`;

  useEffect(() => {   
    dispatch({ type: "setCart", payload: Storageproducts });
  }, []);

  return (
    // <StylesProvider injectFirst>
    <Suspense fallback={<p>Loading...</p>}>
      <ThemeProviderUI theme={THEME}>
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          {props.children}
        </ThemeProvider>
      </ThemeProviderUI>
    </Suspense>
    // </StylesProvider>
  );
};
